import { createSlice } from "@reduxjs/toolkit";
import {
  designationAPI,
  departmentAPI,
  employeeStatusAPI,
  employmentTypeAPI,
  workLocationAPI,
  nationalityAPI,
} from "./API";

const initialState = {
  // Data
  designations: [],
  nationality: [],
  department: [],
  employeeStatus: [],
  employmentType: [],
  workLocation: [],

  // Loading
  loadingDesignations: false,
  loadingNationality: false,
  loadingDepartment: false,
  loadingEmployeeStatus: false,
  loadingEmploymentType: false,
  loadingWorkLocation: false,

  // Error
  errorDesignations: null,
  errorNationality: false,
  errorDepartment: null,
  errorEmployeeStatus: null,
  errorEmploymentType: null,
  errorWorkLocation: null,
};

const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ===========================
    // DESIGNATION
    // ===========================
    builder
      .addCase(designationAPI.fetch.pending, (state) => {
        state.loadingDesignations = true;
      })
      .addCase(designationAPI.fetch.fulfilled, (state, action) => {
        state.loadingDesignations = false;
        state.designations = action.payload;
      })
      .addCase(designationAPI.fetch.rejected, (state, action) => {
        state.loadingDesignations = false;
        state.errorDesignations = action.payload;
      })
      .addCase(nationalityAPI.fetch.pending, (state) => {
        state.loadingNationality = true;
      })
      .addCase(nationalityAPI.fetch.fulfilled, (state, action) => {
        state.loadingNationality = false;
        state.nationality = action.payload;
      })
      .addCase(nationalityAPI.fetch.rejected, (state, action) => {
        state.loadingNationality = false;
        state.errorNationality = action.payload;
      })
      .addCase(departmentAPI.fetch.fulfilled, (state, action) => {
        state.department = action.payload;
      })
      .addCase(employeeStatusAPI.fetch.fulfilled, (state, action) => {
        state.employeeStatus = action.payload;
      })
      .addCase(employmentTypeAPI.fetch.fulfilled, (state, action) => {
        state.employmentType = action.payload;
      })
      .addCase(workLocationAPI.fetch.fulfilled, (state, action) => {
        state.workLocation = action.payload;
      });
  },
});

export const masterDataReducer = masterDataSlice.reducer;
